// extracted by mini-css-extract-plugin
module.exports = {"Languages":"Languages_Languages__2liHU","Icon":"Languages_Icon__1c-ad","LanguagesSelect":"Languages_LanguagesSelect__2CYLJ","minimalist":"Languages_minimalist__inoWI"};